import gql from "graphql-tag";

const apartmentMutations = {


    createApartment: gql`
        mutation CreateApartment($number: String, $storey: String, $tenant_name: String, $tenant_phone_number: String, $notice: String, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $editor_id: Int) {
            createApartment(number: $number, storey: $storey, tenant_name: $tenant_name, tenant_phone_number: $tenant_phone_number, notice: $notice, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, editor_id: $editor_id) {
                id,
                number,
                storey,
                tenant_name,
                tenant_phone_number,
                notice,
                created_at,
                updated_at,
                deleted_at,
                editor_id
            }
        }
    `,
    updateApartment: gql`
        mutation UpdateApartment($id: ID!, $number: String, $storey: String, $tenant_name: String, $tenant_phone_number: String, $notice: String, $created_at: DateTime, $updated_at: DateTime, $deleted_at: DateTime, $editor_id: Int) {
            updateApartment(id: $id, number: $number, storey: $storey, tenant_name: $tenant_name, tenant_phone_number: $tenant_phone_number, notice: $notice, created_at: $created_at, updated_at: $updated_at, deleted_at: $deleted_at, editor_id: $editor_id) {
                id,
                number,
                storey,
                tenant_name,
                tenant_phone_number,
                notice,
                created_at,
                updated_at,
                deleted_at,
                editor_id
            }
        }
    `,
};

export default apartmentMutations;